<div mat-dialog-title>
  <h2 mat-dialog-title>{{ data.title }}</h2>
</div>

<mat-dialog-content class="flex flex-col">
  <span class="mb-5">{{ data.content }}</span>
  <form #filterFormRef [formGroup]="actionDeclinedOpsForm">
    <div>
      <mat-form-field appearance="outline">
        <mat-select placeholder="Action Type" name="actionTypeId" formControlName="actionTypeId">
          <mat-option *ngFor="let actionType of data.actionTypes | orderBy: 'description'" [value]="actionType.id">
            {{ actionType.description }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end end">
  <button mat-button [mat-dialog-close]="false">{{ data.actionOneCaption }}</button>
  <button mat-button [mat-dialog-close]="actionDeclinedOpsForm.value" color="primary"
    [disabled]="actionDeclinedOpsForm.invalid">
    {{ data.actionTwoCaption }}
  </button>
</div>